import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-rfi-related-items',
  standalone: true,
  imports: [CommonModule,MatIconModule],
  templateUrl: './rfi-related-items.component.html',
  styleUrl: './rfi-related-items.component.css'
})
export class RfiRelatedItemsComponent {
  imageSrc: string = 'https://storage.googleapis.com/a1aa/image/oKiO9QOQRjYgPRtVfosGYh7s1Lgh_eDdYRnri-r-vEI.jpg';
  isSidebarOpen = false;
  hasSelectedItems = false; 
  items: any[] = [];
  relatedItems = [
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' },
    { date: '06/01/23', location: 'Level 1 - North Wing - Conference Room' }
  ];
  
  toggleRelatedItems() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  addItem(item: any) {
    if (!this.items.some(existingItem => existingItem.name === item.name)) {
      this.items.push({ ...item });
      this.hasSelectedItems = true; // Show only the table after selection
    }
  }

  removeItem(index: number) {
    this.items.splice(index, 1);
    if (this.items.length === 0) {
      this.hasSelectedItems = false; // Show other content when table is empty
    }
  }
}
